<template>
  <div class="yxy-confirm">
    <y-dialog
      v-model="showValue"
      :mask-transition="maskTransition"
      :dialog-transition="dialogTransition"
      :hide-on-blur="hideOnBlur"
      @on-hide="$emit('on-hide')"
      @on-show="$emit('on-show')">
        <div class="weui-dialog__hd"><strong class="weui_dialog_title">{{title}}</strong></div>
        <div class="weui-dialog__bd"><slot><div v-html="content"></div></slot></div>
        <div class="weui-dialog__ft">
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="onCancel">{{cancelText}}</a>
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="onConfirm">{{confirmText}}</a>
        </div>
    </y-dialog>
  </div>
</template>

<script>
import YDialog from './y-dialog'

export default {
  name: 'confirm',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    maskTransition: {
      type: String,
      default: 'yxy-fade'
    },
    dialogTransition: {
      type: String,
      default: 'yxy-dialog'
    },
    content: String
  },
  data () {
    return {
      showValue: false
    }
  },
  watch: {
    value (val) {
      this.showValue = val
    },
    showValue (val) {
      this.$emit('input', val)
    }
  },
  created () {
    if (this.value) {
      this.showValue = this.value
    }
  },
  methods: {
    onConfirm () {
      this.showValue = false
      this.$emit('on-confirm')
      // 该函数执行完毕后，即该事件处理完毕后，组件变量更新导致子组件刷新触发事件
      // this.showValue = false => dialog.$emit('on-hide') => this.$emit('on-hide')
    },
    onCancel () {
      this.showValue = false
      this.$emit('on-cancel')
    }
  },
  components: {
    YDialog
  }
}
</script>
